export default {
  setSelectedTopic: ({ commit }, topic) => {
    commit('setSelectedTopic', topic);
  },
};
